import React, { useState } from "react";
import CompanyBasedBillableListing from "@/modules/reports/billables/status/company-listing";
import { StatsSection } from "@/modules/reports/billables/status/components/stats-section";
import CollectedFilters from "@/modules/reports/billables/status/collected/filters";
import { statusWiseCollectedDateFilters } from "@/modules/reports/billables/status/constant";
import CommonTable from "components/list/table";
import { getChildData, getChildColumns, getBillableFiltersFromCompanyFilters } from "@/modules/reports/billables/status/child-table-config";

const CollectedBillables = () => {
  const [filters, setFilters] = useState({
    contacts: {
      projects: {
        jobs: {
          billables: {
            ...statusWiseCollectedDateFilters,
            status: {
              _eq: "collected"
            }
          }
        }
      }
    }
  });

  return (
    <div>
      <CompanyBasedBillableListing
        title="Collected Billables"
        status="collected"
        onFiltersChange={setFilters}
        filters={CollectedFilters}
        sortOrder="asc"
        sortBy="contacts.projects.jobs.billables.collected_date"
        enableAccordion={true}
        renderExpandedRow={(row) => (
          <div className="border rounded-md overflow-hidden bg-background">
            <CommonTable
              data={getChildData(row, "collected")}
              columns={getChildColumns("collected")}
              showHeader={true}
            />
          </div>
        )}
        renderContent={() => (
          <StatsSection status="collected" filters={getBillableFiltersFromCompanyFilters(filters)} />
        )}
        statusWiseFilters={{
          contacts: {
            projects: {
              jobs: {
                billables: {
                  ...statusWiseCollectedDateFilters,
                  status: {
                    _eq: "collected"
                  }
                }
              }
            }
          },
        }}
        statusWiseDateFilters={statusWiseCollectedDateFilters}
      />
    </div>
  );
};

export default CollectedBillables;
